const About: React.VFC = () => {
  return <div className="flex justify-center items-center w-screen h-screen">sfsfafafaaagaaf</div>;
};
export default About;
